<template>
  <div id="app">
    <KeepAlive include="disable">
      <router-view />
    </KeepAlive>
  </div>
</template>

<script>
// global config
window.config = Object.assign({}, process.env, window.config)
export default {
  name: 'App'
}
</script>
